/* eslint-disable camelcase */
import { Workshop, WorkshopImage } from '../../models';
import { GET_WORKSHOP, RESET_WORKSHOP } from '../constants/workshop';

export const resetWorkshop = () => {
  return (dispatch) => {
    dispatch({ type: RESET_WORKSHOP });
  };
};

export const getWorkshop = (data) => {
  const { workshop_images } = data;
  const image =
    workshop_images?.length > 0
      ? new WorkshopImage(workshop_images[0].id, workshop_images[0].image)
      : null;

  const { active } = data?.ownership ?? {};

  const workshop = new Workshop(
    data?.id ?? data?.workshop_id,
    data.name,
    data.slug,
    data.country,
    data.city,
    data.street,
    data.street_number,
    data.postcode,
    data.latitude,
    data.longitude,
    data.website,
    data.description,
    data?.number_of_reviews,
    data?.average_rate ?? null,
    active,
    data?.is_owner ?? false,
    image,
  );

  return (dispatch) => {
    dispatch({
      type: GET_WORKSHOP,
      ...workshop,
    });
  };
};
